import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./page/home";
import Homepage from "./page/homepage";
import Login from "./page/Login";
import NoPage from "./page/nopge";
import Category from "./page/category";
import User from "./page/User";
import Userdetail from "./page/Userdetail";
import RentDetail from "./page/RentDetail";
import Notification from "./page/Notification";
import Reward from "./page/reward";
import Report from "./page/report";
import UserDetailall from "./page/UserDetailall";
import RewardDetail from "./page/rewarddetail";
import Editbbps from "./page/editbbps";
import Allpayment from "./page/Allpayment";
import Allpaymentfailedsearch from "./page/Allpaymentfailedsearch";
import Dashboard from "./page/Dashboard";
import Renedit from "./page/Renedit";
import ReneditGateway from "./page/ReneditGateway";
import Reneditedu from "./page/Reneditedu";
import NotificationHistory from "./page/NotificationHistory";

//rent
import UserRent from "./page/UserRent";
import UserRent_copy from "./page/UserRent_copy";

//prerioity
import Sameday from "./page/Sameday";
import Tone from "./page/tone";
import Ttwo from "./page/ttwo";
import Ttthree from "./page/ttthree";
import Ttfour from "./page/ttfour";
import Verified from "./page/verified";
import Freezed from "./page/Freezed";
import Tfouredu from "./page/tfouredu";
import Tfouredunew from "./page/tfouredunew";

import Blukpayment from "./page/Blukpayment";
import UserRentedu from "./page/UserRentedu";
import UserRentedu_copy from "./page/UserRentedu_copy";
import UserRentedu_copywallet from "./page/UserRentedu_copywallet";

import Samedayedu from "./page/Samedayedu";
import Toneedu from "./page/toneedu";
import Ttwoedu from "./page/ttwoedu";
import Tthreeedu from "./page/tthreeedu";
import Verifiededu from "./page/verifiededu";
import Freezededu from "./page/Freezededu";

//Verifieddown
import Verifiededudown from "./page/verifiededudown";
import Verifieddown from "./page/verifieddown";

//coupon
import Rewardcashback from "./page/rewardcashback";
import Rewardcashbackreq from "./page/rewardcashbackreq";

//feedback
import Feedback from "./page/feedback";

//Notification Edit
import Notiedit from "./page/Notiedit";

//credit card apply
import CreditCardApply from "./page/CreditCardApply"

//Other
import Other from "./page/Other"
import Refer from "./page/Refer";
import Fraud from "./page/Fraud";
import Chargeback from "./page/chargeback";
import Chargebackedu from "./page/chargebackedu";

import Bbps_category from "./page/bbps_category";
import Kyc_notlist from "./page/Kyc_notlist";
import Bbps_category_flowise from "./page/bbps_category_flowise";

import Reverse from "./page/Reverse";
import Reverseedu from "./page/Reverseedu";
import UserPlan from "./page/UserPlan";
import User_month_offer from "./page/User_moth_3";
import MonthlyReport from "./page/MonthlyReport";

import User_kyc_not_verified from "./page/User_kyc_not_verified";
import VideoKyc from "./page/VideoKyc";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<UserRent />} />
        <Route path="/chargeback" element={<Chargeback />} />
        <Route path="/login" element={<Login />} />
        <Route path="/fraud" element={<Fraud />} />
        <Route path="/cardapply" element={<CreditCardApply />} />
        <Route path="/notification" element={<Notification />} />
        <Route path="/category" element={<Category />} />
        <Route path="/editbbps" element={<Editbbps />} />
        <Route path="/user" element={<User />} />
        <Route path="/videokyc" element={<VideoKyc />} />
        <Route path="/userplan" element={<UserPlan />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/userdetail" element={<Userdetail />} />
        <Route path="/userrent" element={<UserRent />} /> 
        <Route path="/rentedit" element={<Renedit />} />
        <Route path="/renteditgateway" element={<ReneditGateway />} /> 
        <Route path="/renteditedu" element={<Reneditedu />} /> 
        <Route path="/monthlyreport" element={<MonthlyReport />} />
        <Route path="/notificationhistory" element={<NotificationHistory />} /> 

        <Route path="/chargebackedu" element={<Chargebackedu />} />

        
        <Route path="/kyc_notlist" element={<Kyc_notlist />} /> 

        <Route path="/allpayment" element={<Allpayment />} />
        <Route path="/allpaymentfailedsearch" element={<Allpaymentfailedsearch />} />
        <Route path="/blukpayment" element={<Blukpayment />} />
        <Route path="/rentdetail" element={<RentDetail />} />
        <Route path="/bbps" element={<Home />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/new_payments_utility" element={<UserRent_copy />} />
        <Route path="/new_payments" element={<UserRentedu_copy />} />
        <Route path="/xapaywallet" element={<UserRentedu_copywallet />} />
        <Route path="/reward" element={<Reward />} />
        <Route path="/rewarddetail" element={<RewardDetail />} />
        <Route path="/rewardcashback" element={<Rewardcashback />} />
        <Route path="/report" element={<Report />} />
        <Route path="/useralldetail" element={<UserDetailall />} />

        <Route path="/userrentedu" element={<UserRentedu />} />

        <Route path="/refer" element={<Refer />} /> 

        <Route path="/sameday" element={<Sameday />} />
        <Route path="/t1" element={<Tone />} /> 
        <Route path="/t2" element={<Ttwo />} /> 
        <Route path="/t3" element={<Ttthree />} /> 
        <Route path="/t4" element={<Ttfour />} />
        <Route path="/verified" element={<Verified />} />
        <Route path="/freezed" element={<Freezed />} />
        <Route path="/reverse" element={<Reverse />} />

        <Route path="/samedayedu" element={<Samedayedu />} />
        <Route path="/t1edu" element={<Toneedu />} /> 
        <Route path="/t2edu" element={<Ttwoedu />} /> 
        <Route path="/t3edu" element={<Tthreeedu />} />
        <Route path="/t4edu" element={<Tfouredu />} />
        <Route path="/lowedu" element={<Tfouredunew />} />  
        <Route path="/verifiededu" element={<Verifiededu />} />
        <Route path="/freezededu" element={<Freezededu />} />

        <Route path="/reverseedu" element={<Reverseedu />} />

        <Route path="/verifieddown" element={<Verifieddown />} />
        <Route path="/verifiededudown" element={<Verifiededudown />} />

        <Route path="/feedback" element={<Feedback />} />

        <Route path="/rewardcashbackreq" element={<Rewardcashbackreq />} />

        <Route path="/notiedit" element={<Notiedit />} />

        <Route path="/other" element={<Other />} />
 
        <Route path="/bbps_category" element={<Bbps_category />} />
        <Route path="/bbps_category_flowise" element={<Bbps_category_flowise />} />
        <Route path="/user_month_offer" element={<User_month_offer />} />

        <Route path="/user_kyc_not_verified" element={<User_kyc_not_verified />} />


        <Route path="*" element={<NoPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
